import {
    Box,
    Breadcrumbs,
    Button,
    Chip,
    Drawer,
    Paper,
    Checkbox,
    Typography,
    TextField,
    Tooltip,
    IconButton,
    Backdrop
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
    formatCurrencyValue,
    getLoggedInUserID,
    NPDManagerHead,
    productionManagerHead,
    sourcingManagerHead
} from "../../Utils/Constant";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
    approvePartnerQuotesForMMRfq,
    getQuoteCompareData,
    rejectPartnerQuotesForMMRfq
} from "../Services/MMRfqForm";
import { QuoteDrawer } from "./QuoteDrawer";
import PartnerDetailsDrawer from "../../Sourcing/Partner/PartnerDetails/PartnerDetailsDrawer";
import { ThreeDot } from "react-loading-indicators";
import { showToast } from "../../Components/Toast";
import {
    DataGridPro,
    GridColDef,
    GridPinnedColumnFields
} from "@mui/x-data-grid-pro";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
export const QuoteCompareData = () => {
    const location = useLocation();
    const mmRfqId = location?.state?.rfqData;

    const { rfqData, from = "CURFQAssignedToMe" } = location.state || {};

    const [rows, setRows] = useState<any[]>([]);
    const [approvedData, setApprovedData] = useState<{
        approved: number;
        pending: number;
    }>({
        approved: 0,
        pending: 0
    });

    const approvedCount = rows?.filter(
        (row) => row?.Status === "Approved"
    )?.length;
    const rejectedCount = rows?.filter(
        (row) => row?.Status === "Rejected"
    )?.length;
    const totalCount = rows?.length;

    const [selectionModel, setSelectionModel] = useState<number[]>([]);
    const [rfqEndDate, setRfqEndDate] = useState(false);
    const isSingleRowSelected = selectionModel?.length === 1;
    const isMultipleRowsSelected = selectionModel?.length > 1;

    const [isDropped, setIsDropped] = useState(false);

    const isAllRowsSelected = selectionModel?.length === rows?.length;
    const [open, setOpen] = React.useState(false);
    const [isAcceptDisabled, setIsAcceptDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedPartnerRow, setSelectedPartnerRow] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedQuoteId, setSelectedQuoteId] = useState(null);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [reasonForRejection, setReasonForRejection] = useState("");
    const [isButtonDisable, setIsButtonDisable] = useState(false);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });
    const handleQuoteIdClick = (id) => {
        setSelectedQuoteId(id);
        setDrawerOpen(true);
    };
    const handleCloseDialog = () => {
        setOpenDialog(false);
        setReasonForRejection("");
    };
    const handlePartnerChip = (data) => {
        let obj = {
            unique_ID: data?.Partner_ID,
            navigatingFrom: from,
            ID: mmRfqId?.ID,
            rfqID: mmRfqId?.rfqID,
            rfqData: mmRfqId
        };
        setSelectedPartnerRow(obj);
        setOpenDrawer(true);
    };
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };
    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["__check__", "Partners"],
            right: ["Status"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );

    const fetchQuoteCompareData = async () => {
        setIsLoading(true);
        try {
            let payload = {
                mmRfqId: mmRfqId?.mmRfqRowId,
                partId: mmRfqId?.Part_Row_ID
            };
            const response = await getQuoteCompareData(payload);

            if (response?.status) {
                setIsDropped(response?.isDropped);
                setRows(response?.data);

                const today = new Date();

                const monthNames = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ];

                const parseDate = (dateStr) => {
                    if (!dateStr) return null;
                    const [day, monthStr, year] = dateStr.split("-");
                    const monthIndex = monthNames.indexOf(monthStr);
                    return new Date(year, monthIndex, parseInt(day));
                };

                const rfqEndDate = parseDate(response?.data[0]?.RFQ_End_date);
                const isDisabled = rfqEndDate < today;
                setRfqEndDate(isDisabled);
                let approved =
                    response?.data?.filter(
                        (item) => item?.Status === "Approved"
                    ).length || 0;
                let pending =
                    response?.data?.filter((item) => item?.Status === "Pending")
                        ?.length || 0;

                setApprovedData({ approved, pending });
            } else {
                setRows([]);
            }
        } catch (error) {
            console.error(error);
            setRows([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleApprove = async () => {
        setIsAcceptDisabled(true);

        try {
            const selectedRows = rows.filter((item) =>
                selectionModel.includes(item.ID)
            );
            const promises = selectedRows.map((item) => {
                let payload = {
                    Actor: getLoggedInUserID(),
                    Notifier: item?.Created_By,
                    Partner_Name: item?.Partner_ID,
                    Partner_Status: "Approved",
                    MMRFQ: item?.MMRFQ_Row_ID,
                    Quotation: item?.ID,
                    Part_ID: item?.Part_Row_ID,
                    Company_RFQ: mmRfqId?.ID
                };
                return approvePartnerQuotesForMMRfq(payload);
            });
            const payloadNotification = rows
                ?.filter((item) => selectionModel?.includes(item?.ID)) // Fix: use includes instead of map
                .map((item) => {
                    return {
                        Partner_Name: item?.Partner_Generated_ID,
                        MMRFQ: item?.MMRFQ_ID,
                        Partners: item?.Partners,
                        Part_ID: item?.Part_ID
                    };
                });
            const responses = await Promise.all(promises);
            const isSuccess = responses.every((res) => res?.status);
            if (isSuccess) {
                showToast({
                    message: `Quote(s) approved`,
                    type: "success"
                });
                await fetchQuoteCompareData();
            } else {
                showToast({
                    message: "Quote approval failed",
                    type: "error"
                });
            }
        } catch (err) {
            showToast({
                message: "Quote approval failed",
                type: "error"
            });
        } finally {
            setSelectionModel([]);
            setIsAcceptDisabled(false);
            setOpen(false);
        }
    };

    const handleReject = async () => {
        setIsAcceptDisabled(true);
        setIsButtonDisable(true);
        try {
            const payload = rows
                ?.filter((item) => selectionModel?.includes(item?.ID)) // Fix: use includes instead of map
                .map((item) => {
                    return {
                        Actor: getLoggedInUserID(),
                        Notifier: item?.Created_By,
                        Partner_Name: item?.Partner_ID,
                        Partners: item?.Partners,
                        Partner_Status: "Rejected",
                        Reason: reasonForRejection,
                        MMRFQ: item?.MMRFQ_Row_ID,
                        Quotation: item?.ID,
                        Part_ID: item?.Part_Row_ID,
                        Company_RFQ: mmRfqId?.ID
                    };
                });
            const payloadNotification = rows
                ?.filter((item) => selectionModel?.includes(item?.ID)) // Fix: use includes instead of map
                .map((item) => {
                    return {
                        Partner_Name: item?.Partner_Generated_ID,
                        MMRFQ: item?.MMRFQ_ID,
                        Partners: item?.Partners,
                        Part_ID: item?.Part_ID
                    };
                });
            const response = await rejectPartnerQuotesForMMRfq(payload);
            if (response?.status) {
                showToast({
                    message: "Quote(s) rejected",
                    type: "error"
                });
                await fetchQuoteCompareData();
            } else {
                showToast({
                    message: "Quote(s) rejection failed",
                    type: "error"
                });
            }
        } catch (err) {
            showToast({
                message: "Quote(s) rejection failed",
                type: "error"
            });
        } finally {
            setSelectionModel([]);
            setIsAcceptDisabled(false);
            setOpen(false);
            setIsButtonDisable(false);
            setOpenDialog(false);
            setReasonForRejection("");
        }
    };
    useEffect(() => {
        fetchQuoteCompareData();
    }, []);
    const columns: GridColDef[] = [
        {
            field: "Partners",
            headerName: "Partners",
            width: 180,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Typography
                        variant="body2"
                        className="hoverClr"
                        sx={{ cursor: "pointer" }}
                        onClick={() => handlePartnerChip(params?.row)}
                    >
                        {params.value}
                    </Typography>
                );
            }
        },
        {
            field: "Quote_ID",
            headerName: "Quote ID",
            width: 110,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Chip
                        label={params.value || "-"}
                        size="small"
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleQuoteIdClick(params?.row.ID)}
                    ></Chip>
                );
            }
        },
        {
            field: "Unit_Price",
            headerName: "Unit Price",
            width: 120,
            disableColumnMenu: true,
            renderCell: (params) => {
                return <span>{params?.value || "-"}</span>;
            }
        },
        {
            field: "Quantity_Year",
            headerName: "Quantity/Year",
            width: 140,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const formattedValue = formatCurrencyValue(value);
                return (
                    <div style={{ display: "block" }}>
                        <Typography
                            variant="body2"
                            display="flex"
                            alignItems="center"
                        >
                            <span style={{ paddingLeft: "5px" }}>
                                {formattedValue}
                            </span>
                        </Typography>
                    </div>
                );
            }
        },
        {
            field: "Total_Price",
            headerName: "Total Price",
            width: 130,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const formattedValue = formatCurrencyValue(value);
                return (
                    <div style={{ display: "block" }}>
                        <Typography
                            variant="body2"
                            display="flex"
                            alignItems="center"
                        >
                            <span style={{ paddingLeft: "5px" }}>
                                {formattedValue}
                            </span>
                        </Typography>
                    </div>
                );
            }
        },
        {
            field: "Payment_Term",
            headerName: "Payment Term",
            width: 150,
            disableColumnMenu: true
        },
        {
            field: "Inco_term",
            headerName: "Inco term",
            width: 150,
            disableColumnMenu: true
        },
        {
            field: "Tool_Price",
            headerName: "Tool Price",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Typography variant="body2">
                        {params.value ? `₹ ${params.value}` : "-"}{" "}
                    </Typography>
                );
            }
        },
        {
            field: "Status",
            headerName: "Status",
            width: 120,
            disableColumnMenu: true,
            cellClassName: () => "first-pinned-right",
            headerClassName: "first-pinned-right",
            renderCell: (params) => {
                let color: "success" | "error" | "default";
                switch (params.value) {
                    case "Approved":
                        color = "success";
                        break;
                    case "Rejected":
                        color = "error";
                        break;
                    default:
                        color = "default";
                }
                return (
                    <>
                        <Chip
                            label={params?.value}
                            color={color}
                            variant="outlined"
                            size="small"
                            sx={{
                                ...(params?.value === "Pending" && {
                                    border: "1px solid #ccc",
                                    color: " #797979"
                                })
                            }}
                        />
                        {params?.value === "Rejected" && (
                            <Tooltip title={params?.row?.ReasonForRejection}>
                                <IconButton>
                                    <InfoOutlinedIcon
                                        sx={{ width: "20px", height: "20px" }}
                                    />
                                </IconButton>
                            </Tooltip>
                        )}
                    </>
                );
            }
        }
    ];

    // add this above return (inside AllMmrfq component)
    const parentBreadcrumb =
        from === "Proposals"
            ? { to: "/layout/Proposals", label: "Proposals" }
            : from === "DroppedRfq"
              ? { to: "/layout/DroppedRfq", label: "Dropped CORFQs" }
              : { to: "/layout/CURFQAssignedToMe", label: "Assigned CORFQs" };

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                <Link
                    to={parentBreadcrumb.to}
                    style={{
                        color: "#0070BA",
                        fontSize: "14px",
                        textDecoration: "none"
                    }}
                >
                    {parentBreadcrumb.label}
                </Link>
                {/* <Typography sx={{ fontSize: "14px" }}>
          <Link
            to="/layout/CURFQAssignedToMe"
            style={{
              color: "#0070BA",
              fontSize: "14px",
              textDecoration: "none",
            }}
          >
            Assigned CORFQ to Me
          </Link>
        </Typography> */}
                {[
                    <>
                        <Typography key="final" sx={{ fontSize: "14px" }}>
                            <Link
                                to="/layout/AllMmrfq"
                                style={{
                                    color: "#0070BA",
                                    fontSize: "14px",
                                    textDecoration: "none"
                                }}
                                state={{
                                    rfqData: {
                                        ID: mmRfqId?.ID,
                                        rfqID: mmRfqId?.rfqID
                                    },
                                    from: from
                                }}
                            >
                                All MMRFQs
                            </Link>
                        </Typography>
                    </>
                ]}
                <Typography key="final" sx={{ fontSize: "14px" }}>
                    {/* <Link
            to="#"
            style={{
              fontSize: "14px",
              textDecoration: "none",
            }}
          > */}
                    {mmRfqId?.mmRfqId}
                    {/* </Link> */}
                </Typography>
            </Breadcrumbs>
            <Typography variant="h5" mb={1}>
                Quote comparison for {mmRfqId?.rfqID}
            </Typography>
            <Box
                sx={{
                    borderRadius: "5px",
                    marginTop: "16px",
                    background: "#fff",
                    padding: "15px"
                }}
            >
                {rows?.length > 0 && (
                    <Grid container spacing={2} mb={2}>
                        {/* Search Section */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="body1" fontWeight={"bold"}>
                                {mmRfqId?.mmRfqId} (Part Number -{" "}
                                {mmRfqId?.Part_Number})
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            {(sourcingManagerHead() ||
                                productionManagerHead() ||
                                NPDManagerHead()) && (
                                <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    flexDirection="column"
                                    alignItems="flex-end"
                                >
                                    {/* {rfqEndDate && (
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ mb: 0.5 }} // margin bottom to separate from buttons
                    >
                      CORFQ End Date is Passed - {rows[0]?.RFQ_End_date}
                    </Typography>
                  )} */}

                                    <Box display="flex" gap={2}>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={handleClickOpen}
                                            disabled={
                                                isDropped ||
                                                selectionModel?.length === 0 ||
                                                isAcceptDisabled ||
                                                approvedCount +
                                                    selectionModel?.length ===
                                                    totalCount
                                            }
                                        >
                                            Approve
                                        </Button>

                                        <Button
                                            variant="contained"
                                            color="error"
                                            disabled={
                                                isDropped ||
                                                selectionModel?.length === 0 ||
                                                rejectedCount +
                                                    selectionModel?.length ===
                                                    totalCount
                                            }
                                            onClick={() => setOpenDialog(true)}
                                        >
                                            Reject
                                        </Button>
                                    </Box>
                                </Box>
                            )}
                        </Grid>

                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle
                                id="alert-dialog-title"
                                fontWeight="bold"
                            >
                                Quote Confirmation
                            </DialogTitle>
                            <DialogContent>
                                <Typography>
                                    {selectionModel.length === 1
                                        ? `Are you sure you want to approve the quote from ${rows.find((row) => row.ID === selectionModel[0])?.Partners}?`
                                        : `Are you sure you want to approve the quote from ${rows
                                              .filter((row) =>
                                                  selectionModel.includes(
                                                      row.ID
                                                  )
                                              )
                                              .map((row) => row.Partners)
                                              .join(", ")}?`}
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button color="error" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button
                                    onClick={() => handleApprove()}
                                    disabled={isAcceptDisabled}
                                    autoFocus
                                >
                                    Confirm
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>
                )}
                <Paper
                    sx={{
                        height:
                            rows?.length > 4
                                ? "62vh"
                                : rows?.length > 0
                                  ? "auto"
                                  : "62vh"

                        // width: "100%",
                    }}
                >
                    {!isLoading ? (
                        <DataGridPro
                            pinnedColumns={pinnedColumns}
                            onPinnedColumnsChange={handlePinnedColumnsChange}
                            rows={rows}
                            getRowHeight={() => "auto"}
                            columns={columns}
                            getRowId={(row) => row?.ID}
                            disableRowSelectionOnClick
                            pagination={rows?.length > 10}
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                            pageSizeOptions={[10, 20]}
                            checkboxSelection={
                                sourcingManagerHead() ||
                                productionManagerHead() ||
                                NPDManagerHead()
                            }
                            isRowSelectable={
                                sourcingManagerHead() ||
                                productionManagerHead() ||
                                NPDManagerHead()
                                    ? (params) =>
                                          params?.row?.Status === "Pending"
                                    : undefined
                            }
                            onRowSelectionModelChange={(newSelection) => {
                                setSelectionModel(newSelection as number[]);
                                if (newSelection?.length === 1) {
                                    const selectedRow = rows.find(
                                        (row) => row?.ID === newSelection[0]
                                    );
                                    setSelectedRow(selectedRow || null);
                                } else {
                                    setSelectedRow(null);
                                }
                            }}
                            sx={{
                                width: "100%",
                                "& .MuiDataGrid-columnHeaderTitleContainer": {
                                    "& .MuiDataGrid-sortIcon": {
                                        opacity: "1 !important",
                                        visibility: "visible !important"
                                    }
                                },
                                "& .MuiDataGrid-cell": {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                "& .MuiDataGrid-scrollbarFiller--pinnedRight": {
                                    backgroundColor: "#F4F4F4!important"
                                }
                            }}
                        />
                    ) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="50vh"
                        >
                            <ThreeDot
                                color="#1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Box>
                    )}
                </Paper>

                <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    maxWidth="xs"
                    fullWidth
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">
                        {"Reason for Rejection"}
                    </DialogTitle>
                    <div style={{ padding: "0 20px" }}>
                        <TextField
                            id="outlined-multiline-static"
                            label="Add your comments"
                            multiline
                            rows={4}
                            value={reasonForRejection}
                            onChange={(e) => {
                                const input = e.target.value;
                                const filteredInput = input?.replace(
                                    /[^a-zA-Z0-9\s]/g,
                                    ""
                                ); // allow letters, numbers, and spaces
                                if (filteredInput?.length <= 1000) {
                                    setReasonForRejection(filteredInput);
                                }
                            }}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 1000 }}
                            fullWidth
                            helperText={`${reasonForRejection?.length}/1000 characters`}
                        />
                    </div>
                    <DialogActions>
                        <Button
                            autoFocus
                            color="error"
                            onClick={handleCloseDialog}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={
                                reasonForRejection?.length <= 0 ||
                                isButtonDisable
                            }
                            onClick={() => handleReject()}
                            autoFocus
                        >
                            {!isButtonDisable ? "Submit" : "Submitting"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
            <PartnerDetailsDrawer
                open={openDrawer}
                onClose={handleCloseDrawer}
                selectedPartner={selectedPartnerRow}
            />
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
            >
                {selectedQuoteId && (
                    <QuoteDrawer
                        open={drawerOpen}
                        onClose={() => setDrawerOpen(false)}
                        quoteId={selectedQuoteId}
                    />
                )}
            </Drawer>
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.modal + 1,
                    backgroundColor: "rgba(0,0,0,0.7)"
                }}
                open={isAcceptDisabled}
            >
                <ThreeDot color="#1976d2" size="medium" text="" textColor="" />
            </Backdrop>
        </>
    );
};
